module.exports = __webpack_public_path__ + "img/remove_circle_outline_24px.96d09784.svg";